/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Billing_Board_Block_DecisionInputs */



/**
* | output |
* | --- |
* | "Needs a decision" |
*
* @param {Partner_Billing_Board_Block_DecisionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_block_decision = /** @type {((inputs?: Partner_Billing_Board_Block_DecisionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Block_DecisionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Erfordert eine Entscheidung")
	return /** @type {LocalizedString} */ ("Needs a decision")
});